import instance from "../Config/Config";

export const agent_url = "agent_request"
export const vendor_url = "vendor_request"
export const service_url = "service_request"


export const vendor_store_url = "vendor"
export const specific_vendor_store_url = "vendor"






export const join_as_agent = async()=>{
    const response = await instance.get(`${agent_url}`)
    return response.data
}
export const join_as_vendor = async()=>{
    const response = await instance.get(`${vendor_url}`)
    return response.data
}
export const service_provider = async()=>{
    const response = await instance.get(`${service_url}`)
    return response.data
}

export const get_vendor_store = async(id)=>{
    const response = await instance.get(`${specific_vendor_store_url}/${id}`)
    return response.data
}
export const vendor_store = async(value)=>{
    const response = await instance.post(`${vendor_store_url}`,value)
    return response.data
}
export const vendor_store_edit = async(value)=>{
    const response = await instance.post(`${vendor_store_url}`,value)
    return response.data
}